import React from "react";
import { ReferralBottomNav } from "@/components/ReferralBottomNav";
import { HowItWorks } from "@/components/HowItWorks";
import { Header } from "@/components/Header";
import { useNavigate } from "react-router-dom";

export const HowItWorksPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-primary flex flex-col">
      <Header
        backVisible={true}
        onBack={() => navigate(-1)}
        subtitle="How It Works"
      />
      <div className="px-6 space-y-2 mt-[10vw] mb-4">
        <h2 className="text-md font-semibold text-text-primary text-center">
          How It Works
        </h2>
      </div>
      <div className="flex-1 overflow-y-auto px-4">
        <HowItWorks />
      </div>
      <ReferralBottomNav />
    </div>
  );
};
